import React, {useState, useEffect} from "react";
import { Link } from "react-router-dom";
import { PlanNameToPlanIds } from "../../reducers/models";
import styles from "../../styles/ProfilePlanDetails.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { addPlanToCart } from "../../actions/cart";
import { getEligibleRenewal } from "../../selectors/currentAccountSelector";

interface IProfilePlanDetailsProps {
  icon: string;
  planName: string;
  totalSeats: number;
  devices: any;
  productType: string;
  eligibleRenewal: bb.model.account.IEligibleRenewal
}

export default function ProfilePlanDetails(props:IProfilePlanDetailsProps) {
  const {
    icon,
    planName,
    // status,
    // paymentOccurance,
    // nextPayment,
    // paymentAmount,
    // seatQuantity,
    totalSeats,
    // billingInfo,
    devices,
    // product,
    // duplicateIds,
    productType
  } = props;

  const dispatch = useDispatch()
  const eligibleRenewal = useSelector(getEligibleRenewal);
  
  type NewInfo = {
    url: string
    message: string
    link: boolean
  }
  const [newInfo, setNewInfo] = useState<NewInfo>( {
      url: "",
      message: "",
      link: false
    })



  const getRenewInformation = () => {
    if( planName.includes("Free") ){
      return;
    }

    let canRenew = false

    if( eligibleRenewal.bbbundle === true ){
      canRenew = true
    }else {
      switch(productType){
        case "BB4":
          canRenew = eligibleRenewal.bb4
          break;
        case "BB3": 
          canRenew = eligibleRenewal.bb3
          break;
        case "BB2":
          canRenew = eligibleRenewal.bb2
          break;
        case "Soundbox":
          canRenew = eligibleRenewal.soundbox
          break;
        default:
          canRenew = false;
          break;
      } 
    }
   
    if(!canRenew ){
      return
    }
  
    const temp = {
      url: "",
      message: "",
      link: true
    }
    // TODO: maybe to the endpoint call here and see if the user is actually a bundle or not
    temp.message = "Renew now!"
    const bundleName = "BuildBox Bundle"
    temp.url = eligibleRenewal.bbbundle ? `/purchaseThroughStripeCheckout?renew=${bundleName}`: `/purchaseThroughStripeCheckout?renew=${planName}`
    setNewInfo(temp)
  }

  useEffect( () => {
    getRenewInformation()
    //eslint-disable-next-line
  }, [eligibleRenewal])

  const addHerePlanToCart = () => {
    // const splitNames = planName.split(" ");

    const bbVersion = eligibleRenewal.bbbundle ?  PlanNameToPlanIds["Buildbox Bundle"] : PlanNameToPlanIds[planName];

    // console.log(bbVersion);
    dispatch(addPlanToCart(bbVersion));
  }
  return (
    <div className={styles.profilePlanWrapper}>
      <div className={styles.headerWrapper}>
        <div className={styles.logoTitle}>
          <img src={icon} alt={`${planName}-logo`} />
          <Link
            to={`/account/subscription/${planName}`}
            className={styles.planName}
          >
            {planName}
          </Link>
        </div>
        {devices && (
          <div className={styles.deviceLabel}>
            {totalSeats} {totalSeats === 1 ? "seat" : "seats"} used
            <Link
              to={`/account/subscription/${planName}`}
              className={styles.manageBtn}
              >
              Manage Devices
            </Link>
            {
              newInfo.link && 
                <Link
                  onClick={addHerePlanToCart}
                  to={newInfo.url}
                  className={styles.manageBtn}
                >
                  {newInfo.message}
                </Link>
            }
          </div>

        )}
      </div>
      {/* <div className={styles.planDetails}>
        <div className={styles.planDetail}>
          <span className={styles.label}>Status: </span>
          <b>{status}</b>
        </div>
        <div className={styles.planDetail}>
          <span className={styles.label}>Payment Occurance: </span>
          <b>{paymentOccurance}</b>
        </div>
        <div className={styles.planDetail}>
          <span className={styles.label}>Next Payment: </span>
          <b>{nextPayment}</b>
        </div>
        <div className={styles.planDetail}>
          <span className={styles.label}>Upcoming Bill: </span>
          <b>
            <span>US ${paymentAmount}</span>
            <span className={styles.excludingTax}> (Excluding tax) </span>
          </b>
        </div>
        <div className={styles.planDetail}>
          <span className={styles.label}>Payment Method: </span>
          <b>
            <span>{billingInfo ? billingInfo.brand : "-"} </span>
            <span>{billingInfo ? billingInfo.lastFour : "-"}</span>
            {(nextPayment !== "-" && !duplicateIds) ||
            (nextPayment !== "-" && duplicateIds && product !== "BB2") ? (
              <Link
                to={`/account/subscription/billing?product=${product}`}
                className={styles.manageBtn}
              >
                Manage
              </Link>
            ) : (
              <span />
            )}
          </b>
        </div>
      </div> */}
    </div>
  );
}
